module.exports = "/_next/static/images/Viticci-555a4fa2b45817a492530a51dfe58e1c.jpg";